// Querys and Mutations
import {
    UPDATE,
    GET_BY_ID
} from '@/graphql/config/OtherConfigGraphql'

// models
import { OtherConfigModel, OtherConfigForm } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class OtherConfigService {
    /**
     * Queries
     */
    async getByID (id: number): Promise<OtherConfigModel> {
        const result = await apolloClient.query({
            query: GET_BY_ID,
            variables: {
                id: id
            }
        })
        return result.data.otherConfigById
    }

    /**
     * Mutations
     */
    async update (id: number, form: OtherConfigForm): Promise<OtherConfigModel> {
        const result = await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: form
            }
        })
        return result.data.updateOtherConfig
    }
}

export default new OtherConfigService()
